module.exports = __webpack_public_path__ + "static/homepage_brittney-601516ffd95703a462c1b2c4441997d8.jpg";